import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                prev: 'prev',
                next: 'next'
            }
        }
    }

    init() {
        this.$controls = this.$('controls')[0];
        this.$controlsTop = this.getData('controls-top') === 'true';

        this.swiper = new Swiper(this.$('slideshow')[0], {
            loop: true,
            slidesPerView: 1,
            loopedSlides: 3,
            speed: 600,
            preloadImages: false,
            watchSlidesVisibility: true,
            breakpoints: {
                700: {
                    slidesPerView: 2,
                }
            },
            on: {
                init: () => {
                    if (this.$controlsTop != true ) return
                    setTimeout(() => {
                        this.imageModel = this.$('image')[0].getBoundingClientRect();
                        this.$controls.style.top = `${this.imageModel.height}px`;

                        this.call('update',{},'Scroll','main');
                    }, 1000);

                },
                resize: () => {
                    if (this.$controlsTop != true ) return

                    this.imageModel = this.$('image')[0].getBoundingClientRect();
                    this.$controls.style.top = `${this.imageModel.height}px`;

                    this.call('update', null, 'Scroll')
                },
                slideChange: () => {
                    this.swiper.lazy.load()
                }
            }
        });
    }

    prev() {
        this.swiper.slidePrev();
    }

    next() {
        this.swiper.slideNext();
    }

    inview(e) {
        if(e.obj.el == this.el) {
            this.swiper.lazy.load()
        }
    }

    destroy() {
        this.swiper?.destroy?.()
    }
}
